/**
 * Object which will be used as key in SkinFactory and MediatorMapping.
 */
class SkinKey {

    /**
     * @param {Function} skinClass - Class/function for creating a skin
     */
    constructor(skinClass) {   
        /** 
         * Class/function for creating a skin
         * @member {Function} skinClass 
         * */
        this.skinClass = skinClass;
    }

}
export default SkinKey;